import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const TEST_NAME = 'Partial-Addresses-Checkout';
export const getPartialAddressCheckoutEligibility = (): string =>
    getAbTestV2(TEST_NAME)?.variant || '';
export const trackPartialAddressesCheckoutVariant = (): void => trackAbTestV2Variant(TEST_NAME);
